export default __webpack_public_path__ + "static/media/seafood_cat_disabled.d0a91431.png";